class Accordion {
  private el: HTMLElement;
  private rows: NodeListOf<Element>;
  private buttons: NodeListOf<Element>;

  constructor(el: HTMLElement) {
    this.el = el;
    this.rows = this.el.querySelectorAll('.accordion-row');
    this.buttons = this.el.querySelectorAll('.accordion-button');

    this.init();
  }

  private init() {
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.toggleRow(index);
      });
    });
  }

  private toggleRow(index: number) {
    this.rows.forEach((row, i) => {
      const button = this.buttons[i] as HTMLElement;
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      if (i === index) {
        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
        } else {
          button.setAttribute('aria-expanded', 'true');
        }
      } else {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

export default Accordion;
